import { render, staticRenderFns } from "./TransportationDocumentsPage.vue?vue&type=template&id=553b1bcf&scoped=true"
import script from "./TransportationDocumentsPage.vue?vue&type=script&lang=js"
export * from "./TransportationDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b1bcf",
  null
  
)

export default component.exports